import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { UploadImage } from '../../../../shared/components/UploadImage';
import { useTranslation } from 'react-i18next';
import FilePlaceholder from '../../../../shared/components/placeholder/FilePlaceholder';

interface IModalUploadInvoice {
    show: boolean;
    handleSubmit: (files?: Blob[] | MediaSource[]) => void;
    closeModal: (...args: any) => void;
    rejectReason?: string;
    invoiceFile?: string;
    sequenceNumber?: number;
    invoiceLength?: number;
    campaignTitle?: string;
    isLoading?: boolean;
}

export default function ModalUploadInvoice({
    show,
    handleSubmit,
    closeModal,
    rejectReason,
    invoiceFile,
    sequenceNumber,
    invoiceLength,
    campaignTitle,
}: IModalUploadInvoice) {
    const [files, setFiles] = useState<Blob[] | MediaSource[]>();
    const { t } = useTranslation();
    const deselectFile = () => {
        setFiles(undefined);
    };
    const onCloseAction = () => {
        closeModal();
        deselectFile();
    };
    const handleSubmitAction = () => {
        handleSubmit(files);
        deselectFile();
        closeModal();
    };
    return (
        <Modal
            show={show}
            onHide={onCloseAction}
            className="modal-dark"
            aria-labelledby="contained-modal-title-vcenter"
            centered={true}
        >
            <Modal.Header className="justify-content-start">
                <Modal.Title className="ml-2">
                    {!!invoiceFile ? t('general.button.replace') : t('general.button.upload')} invoice {sequenceNumber}
                    {sequenceNumber && '/'}
                    {invoiceLength} {!!campaignTitle && 'for'} {campaignTitle}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex align-items-center">
                    {!!files ? (
                        <div className="position-relative">
                            <div className="dash-package-close-icon" onClick={deselectFile}>
                                <img src="/icons/closeIcon.svg" alt="Close icon" />
                            </div>
                            <FilePlaceholder file={files} styleContent={{ height: 55, width: 150 }} />
                        </div>
                    ) : (
                        <UploadImage
                            saveFile={setFiles}
                            classes="p-0"
                            acceptedFormats="application/pdf"
                            isMultiple={false}
                            isPreviewArray={false}
                        />
                    )}
                    {!!files && <p className="mb-0 ml-3">{t('influencer.invoice.invoice_upload_desc')}</p>}
                </div>
                {rejectReason && (
                    <>
                        <h6 className="text-danger mt-2 mb-1">{t('influencer.reporting.rejection_reason')}:</h6>
                        <div className="max-h-180px overflow-auto text-danger">{rejectReason}</div>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-end">
                <Button onClick={onCloseAction} variant="outline-primary" className="btn-sm mx-2">
                    {t('general.button.cancel')}
                </Button>
                <Button onClick={handleSubmitAction} className="btn-sm mx-2" disabled={!files}>
                    {!!invoiceFile ? t('general.button.replace') : t('general.button.submit')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
